var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYoutube = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 38,
    viewBox: "0 0 54 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6471 11.9174C53.6471 5.33427 48.3741 0 41.8666 0H11.7805C5.273 0 0 5.33427 0 11.9174V26.0826C0 32.6657 5.273 38 11.7805 38H41.8842C48.3917 38 53.6647 32.6657 53.6647 26.0826V11.9174H53.6471ZM35.9411 20.0704L22.4499 26.8319C21.9209 27.1174 20.1221 26.7249 20.1221 26.1183V12.2385C20.1221 11.6141 21.9385 11.2394 22.4676 11.5427L35.3944 18.661C35.9411 18.9643 36.5054 19.7671 35.9587 20.0704H35.9411Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube.1c2dcb09f2df6e11e7f5d0b29991998f.svg";